import React from 'react';
import cn from 'classnames';

import Badge from 'components/generic/Badge.component';
import Video from 'components/generic/Video.component';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

import CN from './VideoCard.module.scss';

const VideoCard = ({ src, title, badgeName, badgeVariant, showBadge, children, tag, variant }) => (
  <div
    data-bem="VideoCard"
    data-tag={fromAnyToTrimmed(tag)}
    className={cn({
      [CN.component]: true,
      [CN[`${variant}Variant`]]: variant,
    })}
  >
    <div className={CN.column} data-bem="VideoCard__text-column">
      <div className={CN.textContainer}> {children}</div>
    </div>
    <div className={CN.column} data-bem="VideoCard__video-column">
      <div className={CN.videoContainer}>
        {showBadge && (
          <div className={CN.videoBadge}>
            <Badge name={badgeName} variant={badgeVariant} />
          </div>
        )}

        <Video src={src} title={title} />
      </div>
    </div>
  </div>
);

export default VideoCard;
